import React, { useEffect } from "react"
import { navigate } from 'gatsby'

const RedirectPage = () => {

  useEffect(() => {
    navigate('/en')
  })
  
  return <></>;
}

export default RedirectPage
